import { Children, PropsWithChildren } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export type LpohTabsProps = {
	value: string;
	onValueChange: (value: string) => void;
	tabOptions: {
		value: string;
		label: string;
		disabled?: boolean;
	}[];
} & PropsWithChildren;

export const LpohTabs = (props: LpohTabsProps) => {
	const { value, onValueChange, tabOptions, children } = props;
	const childrenArray = Children.toArray(children);
	return (
		<Tabs value={value} className="w-full" onValueChange={onValueChange}>
			<TabsList className="flex justify-start min-w-80">
				{tabOptions.map(tab => (
					<TabsTrigger key={tab.value} value={tab.value} disabled={tab.disabled} className="flex-1 ">
						{tab.label}
					</TabsTrigger>
				))}
			</TabsList>
			{childrenArray.map((tab, index) => (
				<TabsContent key={tabOptions[index].value} value={tabOptions[index].value} className="pt-5">
					{tab}
				</TabsContent>
			))}
		</Tabs>
	);
};
